import "../styles/Login.css";

import { Box, Card, CardContent, TextField, Typography } from "@mui/material";

import Button from "../components/atoms/Button";
import Label from "../components/atoms/Label";
import React, { useState } from "react";
import TextFieldWithImage from "../components/atoms/TextFieldWithImage";
import passwordImage from "../assets/lock.svg";
import signupImage from "../assets/signup_image.svg";
import { useLogin } from "../hooks/useLogin";
import userIcon from "../assets/user_icon.svg";
import ForgotPassword from './ForgotPassword';

function Login({ openSignUpModal, closeLoginModal }) {
  const {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    error,
    handleLogin,
  } = useLogin();

  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const onLoginClick = async (e) => {
    e.preventDefault();
    const success = await handleLogin();
    if (success) {
      closeLoginModal();
      // Handle successful login
      // For example, redirect to dashboard
    }
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple regex to validate email format
    if (!value.trim()) {
      return "Email is required.";
    } else if (!emailRegex.test(value)) {
      return "Enter a valid email address.";
    }
    return ""; // No error
  };

  const validatePassword = (pwd) => {
    if (!pwd) {
      return "Password is required.";
    }
    // Add more password requirements as needed
    return "";
  };

  if (showForgotPassword) {
    return (
      <ForgotPassword 
        onBackToLogin={() => setShowForgotPassword(false)}
        initialEmail={email}
      />
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="main_div">
        <div className="left-column">
          <div className="hide-register-text">
            <Label
              label="Register"
              fontSize={"24px"}
              padding={"10px"}
              color={"#545454"}
              fontWeight={"700"}
            />
            <Label
              label="Register now and feel the New Digital World"
              fontSize={"14px"}
              padding={"10px"}
              color={"#545454"}
              fontWeight={"700"}
            />

            <Button
              className="log-in-button"
              label="Sign Up"
              style={{ width: "auto" }}
              onClick={openSignUpModal}
            ></Button>
          </div>
          <Box
            component="img"
            src={signupImage}
            style={{ height: "375px" }}
            className="signup-image"
          />
        </div>
        <div className="right-column">
          <Label
            label="Login"
            fontSize={"32px"}
            padding={"10px"}
            color={"#545454"}
            fontWeight={"700"}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              width: "100%",
              maxWidth: "346px",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onLoginClick(e);
              }
            }}
            tabIndex={0}
          >
            <TextFieldWithImage
              placeholder={"Enter email"}
              src={userIcon}
              padding={"100px"}
              validate={validateEmail}
              width="100%"
              required={true}
              value={email}
              onChange={(value) => setEmail(value)}
            />

            <TextFieldWithImage
              placeholder={"Enter password"}
              src={passwordImage}
              padding={"10px"}
              width="100%"
              type="password"
              validate={validatePassword}
              value={password}
              onChange={(value) => setPassword(value)}
            />
            <div style={{ display: "flex", width: "100%", justifyContent: "end"}}>
              <Label
                style={{ cursor: "pointer" }}
                label="Forgot Password?"
                fontSize={"14px"}
                padding={"10px"}
                color={"#08BD80"}
                fontWeight={"700"}
                onClick={() => setShowForgotPassword(true)}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              width: "100%",
              maxWidth: "346px",
            }}
          >
            <Button
              className="login-button"
              label={loading ? "Logging in..." : "Login"}
              style={{ width: "100%" }}
              onClick={onLoginClick}
              isLoading={loading}
              disabled={loading}
            ></Button>
          </div>
          {error && (
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                marginLeft: "10px",
                marginTop: "2px",
                textAlign: "start",
              }}
            >
              <span style={{ color: "red", fontSize: "14px" }}>{error}</span>
            </div>
          )}
          <div className="dont-have-an-account">
            <Label
              label="Don't have an account?"
              fontSize={"14px"}
              padding={"10px"}
              color={"#545454"}
              fontWeight={"700"}
            />
            <Button
              className="log-in-button"
              label="Sign Up"
              style={{ width: "100%" }}
              onClick={openSignUpModal}
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
